//NEXT_PUBLIC_DEPICT_MERCHANT is for QA
//DEPICT_MERCHANT is for PROD
export const depictMerchant =
    process.env.NEXT_PUBLIC_DEPICT_MERCHANT || process.env.DEPICT_MERCHANT || "poc"
